<template>
    <div class="card">
        <div class="card-body">
            <h4 class="header-title mt-0">{{titleHeader}}</h4>
            <div class="px-4" v-if="showCountry||showDomain">
                <div class="row">
                    <div class="col-lg-6" v-if="showDomain">
                        <DropDownVue :items="itemsDomain"
                                     :label="titles.placeholderDomainPack"
                                     :validate="$v.actualDomain.id"
                                     @method="handleChangeDropDown"
                                     icon="fas fa-globe"
                                     inputKey="actualDomain"
                                     itemKey="id"
                                     itemValue="name"
                        />
                    </div>
                    <div class="col-lg-6" v-if="showCountry">
                        <DropDownVue :items="itemsCountry"
                                     :label="titles.placeholderCountryPack"
                                     :validate="$v.actualCountry.id"
                                     @method="handleChangeDropDown"
                                     icon="fas fa-globe"
                                     inputKey="actualCountry"
                                     itemKey="id"
                                     itemValue="name"
                        />
                    </div>
                </div>
                <hr>
            </div>
            <Loading v-if="inProgess"/>
            <div class="px-4">
                <div class="row">
                    <PackTypePack
                            :country="actualCountry"
                            :domain="actualDomain"
                            :key="item.id"
                            :packCountryDomain="item"
                            :packsToAdd="itemsPackCountryDomain"
                            :showButton="true"
                            v-for="item in itemsPackCountryDomain"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {packCountryDomain} from '../../shared/models/packCountryDomain';
    import {domain} from '@/components/shared/models/domain';
    import {getAllDomains} from '@/components/shared/services/domain.service';
    import {country} from '@/components/shared/models/country';
    import {titles} from '@/utils/general/titles';
    import DropDownVue from '../../common/DropDownVue';
    import {getAllTypePacks} from '@/components/shared/services/typePack.service';
    import {typePack} from '@/components/shared/models/typePack';
    import PackTypePack from '../../shared/formInfo/PackTypePack';
    import {filterMixin} from '@/utils/filterMixin';
    import {getAllPackCountryDomain} from '../../shared/services/packCountryDomain.service';
    import {backMixin} from '../../../utils/general/backMixin';
    import {DEFAULT_COUNTRY_CODE} from '../../../config/config';
    import Loading from '../../common/Loading';

    export default {
        name: 'packDomain',
        props: {
            showDomain: {
                type: Boolean,
                default: true
            },
            showCountry: {
                type: Boolean,
                default: true
            },
            DomainPack: {
                type: Object,
                default() {
                    return domain();
                }
            }
        },
        components: {
            Loading,
            DropDownVue, PackTypePack
        },
        data() {
            return {
                titles,
                itemsDomain: [],
                isItemsDomain: true,
                itemsCountry: [],
                isItemsCountry: true,
                itemsTypePack: [],
                filterQuery: '',
                filterList: [],
                showPacks: false,
                itemsPackCountryDomain: [],
                actualDomain: domain(),
                actualCountry: country(),
                pages: [],
                titleHeader: titles.packConfigTitle,
                inProgess: null
            };
        },
        created() {
            this.loadCountries(true);
            if (this.DomainPack.id == null) {
                this.loadDomains();
            } else {
                this.inProgess = true;
                this.titleHeader = this.titles.defaultPack;
                this.actualDomain = this.DomainPack;
                this.showPacks = true;
                this.itemsPackCountryDomain = [];
            }
        },
        mixins: [filterMixin, backMixin],
        methods: {
            async loadDomains() {
                this.filterList = [];
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'isActive',
                    '1',
                    null
                );
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'enabled',
                    '1',
                    null
                );
                getAllDomains(
                    null, null, null, this.filterQuery
                ).then(response => {
                    this.itemsDomain = response.data['hydra:member'];
                    this.itemsDomain = this.itemsDomain.map(item => domain(item));
                    this.isItemsDomain = false;
                });
            },
            async loadTypePack() {
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'enabled',
                    '1',
                    null
                );
                this.orderQueryGenerator('packOrder', false);
                await getAllTypePacks(
                    this.filterQuery, this.sort
                ).then(response => {
                    this.itemsTypePack = response.data['hydra:member'];
                    const itemsPackCountryDomainTemporary = [];
                    this.itemsTypePack = this.itemsTypePack.map(item => {
                        const itemTypePack = this.itemsPackCountryDomain.find(itemTP => itemTP.typePack.id === item.id);
                        let actualPackCountryDomain = packCountryDomain();
                        if (itemTypePack === undefined) {
                            actualPackCountryDomain.country = this.actualCountry;
                            actualPackCountryDomain.domain = this.actualDomain;
                            actualPackCountryDomain.typePack = typePack(item);
                        } else {
                            actualPackCountryDomain = itemTypePack;
                        }
                        itemsPackCountryDomainTemporary.push(actualPackCountryDomain);
                        return typePack(item);
                    });
                    this.itemsPackCountryDomain = itemsPackCountryDomainTemporary;
                    this.showPacks = true;
                });
            },
            async loadPackCountryDomain(idDomain, idCountry) {
                this.itemsPackCountryDomain = [];
                this.filterList = [];
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'domain.id',
                    idDomain,
                    null
                );
                this.filterList = this.filterQueryGenerator(
                    this.filterList,
                    'country.id',
                    idCountry,
                    null
                );
                getAllPackCountryDomain(
                    null, null, null, this.filterQuery
                ).then(response => {
                    this.itemsPackCountryDomain = response.data['hydra:member'];
                    this.itemsPackCountryDomain = this.itemsPackCountryDomain.map(item => packCountryDomain(item));
                    this.loadTypePack();
                    this.inProgess = false;
                });
            },
            handleChangeDropDown(val, inputKey) {
                this[inputKey] = val;
                this.itemsPackCountryDomain = [];
                if (!this.isItemsCountry && !this.isItemsDomain && this.actualCountry && this.actualCountry.code != DEFAULT_COUNTRY_CODE
                    && this.actualDomain && this.actualDomain.id != null) {
                    this.loadPackCountryDomain(this.actualDomain.id, this.actualCountry.id);
                    this.inProgess = true;
                }
            }
        },
        validations: {
            actualDomain: {
                id: {}
            },
            actualCountry: {
                id: {}
            }
        }
    };
</script>

<style scoped>
    @import '../../../assets/style/css/appStyle.css';
</style>